

export function bindPostCodeValidator(form,fieldname) 
{
    form.get(fieldname).valueChanges.subscribe(x => {
      let postcode = parseInt(form.get(fieldname).value);


      if( postcode >=  50000   && 60000 >= postcode) //KL
        return;
      else if( postcode >=62000   && 62988 >= postcode) //PUTRAJAYA
        return;
      else if( postcode >=40000   && 48300 >= postcode) //Selangor 
        return;
      else if( postcode >=63000    && 68100 >= postcode) //Selangor 
        return;
      else if( postcode >=20000     && 24300 >= postcode) //Terengganu 
        return;
      else if( postcode >= 5000     && 9810 >= postcode) //Kedah  
        return;
      else if( postcode >= 15000     && 18500 >= postcode) //Kelantan   
        return;
      else if( postcode >= 70000     && 73509 >= postcode) //Negeri Sembilan   
        return;
      else if( postcode >= 10000     && 14400 >= postcode) //Pulau Pinang   
        return;
      else if( postcode >= 75000     && 78309 >= postcode) //Melaka
        return;
      else if( postcode >= 1000     && 2000 >= postcode) //Pulau Pinang   
        return;       
      else if( postcode >= 30000     && 36810 >= postcode) //Perak 
        return; 
      else if( postcode >= 25000     && 28800 >= postcode) //Pahang  
        return;    
       else if( postcode >= 39000     && 39200 >= postcode) //Pahang  
        return;    
      else if( postcode >= 79000     && 86900 >= postcode) //Johor  
        return;   

      form.controls[fieldname].setErrors({ invalidPostCode: true });
    });
}

export function getState(postcode){
  if( postcode >=  50000   && 60000 >= postcode) //KL
    return 'Kuala Lumpur';
  else if( postcode >=62000   && 62988 >= postcode) //PUTRAJAYA
    return 'Putrajaya';
  else if( postcode >=40000   && 48300 >= postcode) //Selangor 
    return 'Selangor';
  else if( postcode >=63000    && 68100 >= postcode) //Selangor 
    return 'Selangor';
  else if( postcode >=20000     && 24300 >= postcode) //Terengganu 
    return 'Terengganu';
  else if( postcode >= 5000     && 9810 >= postcode) //Kedah  
    return 'Kedah';
  else if( postcode >= 15000     && 18500 >= postcode) //Kelantan   
    return 'Kelantan';
  else if( postcode >= 70000     && 73509 >= postcode) //Negeri Sembilan   
    return 'Negeri Sembilan';
  else if( postcode >= 10000     && 14400 >= postcode) //Pulau Pinang   
    return 'Pulau Pinang';
  else if( postcode >= 75000     && 78309 >= postcode) //Melaka
    return 'Melaka';
  else if( postcode >= 1000     && 2000 >= postcode) //Perlis   
    return 'Perlis';       
  else if( postcode >= 30000     && 36810 >= postcode) //Perak 
    return 'Perak'; 
  else if( postcode >= 25000     && 28800 >= postcode) //Pahang  
    return 'Pahang';    
  else if( postcode >= 39000     && 39200 >= postcode) //Pahang  
    return 'Pahang';    
  else if( postcode >= 79000     && 86900 >= postcode) //Johor  
    return 'Johor'; 
}


